import {
  mapCareerPathResponseToCareerPath,
  ContentNugget,
  ContentNuggetBookmark,
} from '@backrs_ui/common-ui';

export function mapBookmarksToContentNugget(bookmarks: ContentNuggetBookmark[]): ContentNugget[] {
  const bookmarksAsNuggets: ContentNugget[] = [...bookmarks]
    .sort((a, b) => {
      const aCreatedAt = new Date(a?.created_at).getTime();
      const bCreatedAt = new Date(b?.created_at).getTime();

      return bCreatedAt - aCreatedAt;
    })
    .map((bookmark) => {
      switch (true) {
        case !!bookmark.content_nugget:
          return bookmark.content_nugget;

        case !!bookmark.content_college:
          return {
            id: bookmark.content_college.id,
            title: bookmark.content_college.school_name,
            description: bookmark.content_college.description,
            slug: bookmark.content_college.id.toString(),
            variant: 'institution',
            college_info: bookmark.content_college,
            is_browsable: false,
            content_nugget_theme: 'University',
          };

        case !!bookmark.content_external_profile:
          return {
            id: bookmark.content_external_profile.id,
            title: `Connect with and Review ${bookmark.content_external_profile.first_name} ${bookmark.content_external_profile.last_name}'s Profile`,
            description: bookmark.content_external_profile.description,
            slug: bookmark.content_external_profile.id.toString(),
            variant: 'profile-external',
            content_nugget_theme: 'Profile',
            is_browsable: false,
            external_profile_info: bookmark.content_external_profile,
          };

        case !!bookmark.content_internship:
          return {
            id: bookmark.content_internship.id,
            title: bookmark.content_internship.role_title,
            description: bookmark.content_internship.ai_description,
            slug: bookmark.content_internship.id.toString(),
            star_rating: 0,
            value_rating: 0,
            variant: 'internship',
            content_nugget_theme: 'Internship',
            is_browsable: false,
            internship_info: bookmark.content_internship,
          };

        case !!bookmark.content_scholarship:
          return {
            id: bookmark.content_scholarship.id,
            title: bookmark.content_scholarship.name,
            description: bookmark.content_scholarship.description,
            slug: bookmark.content_scholarship.donor,
            format: 'scholarships',
            star_rating: 0,
            value_rating: 0,
            variant: 'scholarships',
            scholarship_info: bookmark.content_scholarship,
            is_browsable: false,
          };
        case !!bookmark.content_profile:
          return {
            id: bookmark.content_profile.id,
            title: `Connect with and Review ${`${bookmark.content_profile.first_name ? bookmark.content_profile.first_name : ''} ${bookmark.content_profile.last_name ? `${bookmark.content_profile.last_name[0]}.` : ''}`}'s Profile`,
            description: bookmark.content_profile.bio || '',
            slug: bookmark.content_profile.email,
            format: 'profile',
            star_rating: 0,
            content_nugget_theme: 'Profile',
            value_rating: 0,
            variant: 'profile-internal',
            is_browsable: false,
            profile_info: bookmark.content_profile,
          };
        case !!bookmark.content_career_path:
          return {
            id: bookmark.content_career_path.id,
            title: bookmark.content_career_path.name,
            description: bookmark.content_career_path.description,
            slug: bookmark.content_career_path.id.toString(),
            star_rating: 0,
            value_rating: 0,
            variant: 'career-path',
            content_nugget_theme: 'Career Path',
            is_browsable: false,
            career_path_info: mapCareerPathResponseToCareerPath(bookmark.content_career_path),
          };

        case !!bookmark.content_post:
          return {
            id: bookmark.content_post.id,
            title: bookmark.content_post?.author?.first_name
              ? `${bookmark.content_post.author.first_name}'s Thread`
              : '',
            description: bookmark.content_post?.body,
            slug: bookmark.content_post?.id?.toString(),
            star_rating: 0,
            value_rating: 0,
            variant: 'post',
            content_nugget_theme: 'Community',
            is_browsable: false,
            post_info: bookmark.content_post,
          };
        default:
          return null;
      }
    })
    .filter((nugget) => nugget) as ContentNugget[];

  return bookmarksAsNuggets;
}
